import { render } from "./ModelCard.vue?vue&type=template&id=2b2126ec"
import script from "./ModelCard.vue?vue&type=script&lang=js"
export * from "./ModelCard.vue?vue&type=script&lang=js"

import "./ModelCard.vue?vue&type=style&index=0&id=2b2126ec&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__